import React from 'react';
import { Home, AlertTriangle } from 'lucide-react';
import LogoCoordo from '../Styles/Pictures/logo_coordogec.jpg';
import '../Styles/Error404Page.scss';

const Error404Page = () => {
  const handleLogin = () => {
    window.location.href = '/login';
  };

  return (
    <div className="error-container">
      <div className="error-content">
        {/* Logo/Brand */}
        <div className="brand-section">
          <div className="brand-icon">
            <img src={LogoCoordo} alt="logo coordogec" />
          </div>
          <h1 className="brand-title">
            ERP - COORDOGEC
          </h1>
        </div>

        <div className="error-main">
          <div className="error-number-container">
            <h2 className="error-number">
              404
            </h2>
            <div className="error-icon-overlay">
              <AlertTriangle className="warning-icon" />
            </div>
          </div>

          <h3 className="error-title">
            Page introuvable
          </h3>

          <p className="error-description">
            Désolé, la page que vous recherchez n'existe pas.<br />
            Vérifiez l'URL ou connectez-vous à votre compte.
          </p>
        </div>

        <div className="action-section">
          <button
            onClick={handleLogin}
            className="login-button"
          >
            <Home className="button-icon" />
            Connexion
          </button>
        </div>

        <div className="info-section">
          <p className="info-text">
            Système de gestion d'entreprise COORDOGEC
          </p>
          <p className="info-description">
            Plateforme sécurisée pour la gestion de vos données d'entreprise.<br />
            Connectez-vous pour accéder à vos fonctionnalités.
          </p>
        </div>

        <div className="footer404">
          © {new Date().getFullYear()} COORDOGEC. Tous droits réservés.
        </div>
      </div>
    </div>
  );
};

export default Error404Page;